import { Navigate } from 'react-router-dom';

const Root = () => {
    return <Navigate to="/account/temple-login" replace />;
};

export default Root;